<div class="oc column">
  N° OC
</div>
<div class="in-timestamp column">
  Data/Hora de Emissão
</div>
<div class="nfe column">
  N° NFe / Série
</div>
<div class="in-timestamp column">
  Data/Hora de Emissão
</div>
<div class="document column">
  CNPJ
</div>
<div class="name column">
  Razão Social
</div>
<div class="status column">
  Status
</div>
<div class="messages column">
  Comentários
</div>
